import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { ROUTE_PATHS } from 'router/routes';
// import { lazyImportComponent } from 'shared/helpers/lazyImportComponent'

const SoftionSportPage = React.lazy(() => import('pages/SoftionSportPage/SoftionSportPage'))

export class SoftionSportModule {
  getRoutes() {
    return (
      <Route key={ROUTE_PATHS.SOFTION_SPORT} path={ROUTE_PATHS.SOFTION_SPORT}>
        <Switch>
          <Route
            exact
            key={ROUTE_PATHS.SOFTION_SPORT}
            path={ROUTE_PATHS.SOFTION_SPORT}
            component={() => <SoftionSportPage />}
          />
          <Route
            exact
            key={ROUTE_PATHS.SOFTION_SPORT_LIVE}
            path={ROUTE_PATHS.SOFTION_SPORT_LIVE}
            component={() => <SoftionSportPage isLive />}
          />
        </Switch>
      </Route>
    )
  }
}
